@let vend = vendor();
@if (!vend?.hasShop) {
  <a class="vendor" [routerLink]="['/products']" [queryParams]="{ ao: true, ven: vend?.vendorNumber }">{{ vend?.name }}</a>
} @else {
  <a class="vendor" [routerLink]="['/vendors', vend?.vendorNumber]">{{ vend?.name }}</a>
}
